import validate from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45initial_45global from "/usr/src/nuxt-app/middleware/01-initial.global.js";
import _02_45navigation_45global from "/usr/src/nuxt-app/middleware/02-navigation.global.js";
import manifest_45route_45rule from "/usr/src/nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45initial_45global,
  _02_45navigation_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}